import * as tslib_1 from "tslib";
import { SvgIcon } from '@nextiva/next-ui';
import { SentimentColor } from "../../../constants";
import React from 'react';
import iconViewContentIcon from './assets/icons/icon-view-content.svg';
import iconViewDissatisfiedIcon from './assets/icons/icon-view-dissatisfied.svg';
import iconViewHappyIcon from './assets/icons/icon-view-happy.svg';
import iconViewSatisfiedIcon from './assets/icons/icon-view-satisfied.svg';
import iconViewUnhappyIcon from './assets/icons/icon-view-unhappy.svg';
import "./IconViewChart.css";

var getSvgSrcBySentiment = function getSvgSrcBySentiment(sentiment) {
  var _a;

  if (!sentiment) {
    return undefined;
  }

  return (_a = {}, _a[SentimentColor.HAPPY] = iconViewHappyIcon, _a[SentimentColor.SATISFIED] = iconViewSatisfiedIcon, _a[SentimentColor.CONTENT] = iconViewContentIcon, _a[SentimentColor.DISSATISFIED] = iconViewDissatisfiedIcon, _a[SentimentColor.UNHAPPY] = iconViewUnhappyIcon, _a)[sentiment];
};

var IconViewChartSvg = function IconViewChartSvg(_a) {
  var color = _a.color,
      other = tslib_1.__rest(_a, ["color"]);

  return React.createElement(SvgIcon, tslib_1.__assign({
    className: "icon-view-chart-svg icon-view-chart-svg__" + color,
    src: getSvgSrcBySentiment(color)
  }, other));
};

export default IconViewChartSvg;